import React from 'react';
import './PromoteProductDrawer.css';

function PromoteProductDrawer({ visible, onClose, onSubmit, acceptTerms, setAcceptTerms }) {
  if (!visible) return null;

  return (
    <div className="drawer-backdrop" onClick={onClose}>
      <div className="drawer-panel" onClick={(e) => e.stopPropagation()}>
        <h3>Promote Your Product</h3>
        <p>
          Your product will appear more prominently in the Marketplace and Feed for 7 days.
        </p>

        <label className="drawer-checkbox">
          <input
            type="checkbox"
            checked={acceptTerms}
            onChange={(e) => setAcceptTerms(e.target.checked)}
          />
          I accept the terms and conditions.
        </label>

        <button
          className="drawer-submit-btn"
          disabled={!acceptTerms}
          onClick={onSubmit}
        >
          Promote
        </button>

        <button className="drawer-cancel-btn" onClick={onClose}>
          Cancel
        </button>
      </div>
    </div>
  );
}

export default PromoteProductDrawer;
